import { RegenerateGuides } from 'domain/usecases/surgical-order/regenerate-guides'
import { SurgicalOrderRepository } from 'repository/repositories/surgical-order/surgical-order-repository'

export class RemoteGenerateGuides implements RegenerateGuides {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  regenerate(params: RegenerateGuides.Params): Promise<RegenerateGuides.Model> {
    return this.surgicalOrderRepository.regenerateGuides(params)
  }
}
